import { useSound } from './useSound.hook';

/**
 * A hook for playing cashout sound effects
 * @param options Optional configuration options for the sound
 * @returns An object with functions to control the cashout sound
 */
export const useCashoutSound = (options?: {
  volume?: number;
  interrupt?: boolean;
  playbackRate?: number;
}) => {
  return useSound('cashout', {
    volume: options?.volume ?? 0.2, // Slightly louder for cashout success
    interrupt: options?.interrupt ?? true, // Allow interrupting previous cashout sounds
    playbackRate: options?.playbackRate ?? 1,
    keepSoundAlive: true,
  });
};
